module.exports = __webpack_public_path__ + "img/home-github-disabled.1ddbbeb7.png";